<template>
  <div class="info_item px-2" :class="data.parent ? 'py-1 pl-5 info_item--child' : 'py-2' + (data.name === 'new' ? ' info_item--highlight fw700' : '')">
    <div class="info_item__row">
      <div class="info_item__text primary--text">{{ formatViewData.title }}</div>
      <div class="info_item__ellipse" :style="{ background: formatViewData.color }" />
    </div>
    <div>{{ data.count }} {{localStorage.translations.pages.common.measure['piece']}}</div>
  </div>
</template>

<script>
export default {
  name: 'HomeWidgetInfoItem',
  props: {
    data: Object,
  },
  data() {
    return {}
  },
  computed: {
    formatViewData() {
      let result = {
        title: '',
        color: '',
      }
      switch (this.data.name) {
        case 'started':
          result.title = this.localStorage.translations.pages.common.text.start
          result.color = '#219653'
          break
        case 'stopped':
          result.title = this.localStorage.translations.pages.common.text.stop
          result.color = '#56CCF2'
          break
        case 'with_reports':
          result.title = this.localStorage.translations.pages.common.text['add_report']
          result.color = '#F2994A'
          break
        case 'not_started':
          result.title = this.localStorage.translations.pages.common.text['not_started']
          result.color = '#EB5757'
          break
        case 'free_workers':
          result.title = this.localStorage.translations.pages.common.text['free_workers']
          result.color = '#F2C94C'
          break
        default:
          const randomColor = Math.floor(Math.random() * 16777215).toString(16)
          result.title = this.data.name
          result.color = this.data.color || '#' + randomColor
      }
      return result
    },
  },
}
</script>

<style scoped lang="scss">
.info_item {
  display: grid;
  width: 100%;
  grid-template-columns: auto minmax(70px, 20%);
  align-items: center;
  &__row {
    display: grid;
    grid-template-columns: auto 20%;
    align-items: center;
  }
  &__ellipse {
    width: 20px;
    height: 20px;
    border-radius: 50%;
  }
  &--highlight {
    background: #F3F3F3;
  }
  &--child {
    position: relative;
    .info_item__row {
      grid-template-columns: auto calc(20% + 5px);
    }
    &::before,
    &::after {
      content: '';
      position: absolute;
      height: 90%;
      width: 10px;
      top: -12px;
      left: 8px;
    }
    &::before {
      border-left: 1px dashed #277faf;
    }
    &::after {
      border-bottom: 1px dashed #277faf;
    }
  }
}
</style>
